
const Reducer = (state, action) => {
  switch (action.type) {

    case 'Dashboard_Data':
      return {
        ...state,
        Dashboard_Data: {
          ...state.Dashboard_Data,
          [action?.payload?.name]: action?.payload?.data,
        },
      };
    case 'ADD_DATA':
      return {
        ...state,
        [action?.payload?.name]: action?.payload?.data,
      };
    case 'LOGOUT':
      return {
        ...state,
        userData: {},
        friends: [],
      };

    default:
      break;
  }
};

export default Reducer;